import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'
import { API_ENDPOINTS } from '@/config/api'
import type { CMMDashboardStats } from '@/types'

/**
 * Hook per ottenere le statistiche dashboard CMM.
 * Usato da DashboardMobileFirst e DashboardAdaptive.
 */
export const useCMMStats = () => {
  return useQuery({
    queryKey: ['cmm-stats'],
    queryFn: async () => {
      try {
        const response = await axiosInstance.get<CMMDashboardStats>(
          API_ENDPOINTS.CMM_STATS
        )
        return response.data
      } catch (error: any) {
        console.error('❌ Error loading CMM stats:', error.message)
        throw error
      }
    },
    staleTime: 1000 * 30,
  })
}
